// extracted by mini-css-extract-plugin
module.exports = {"card":"AreapageSituationCardPart_card__MG_tp","disabled":"AreapageSituationCardPart_disabled__2Sk4m","disabledMsg":"AreapageSituationCardPart_disabledMsg__8lTcB"};